import { Form} from "react-bootstrap";
import { Dispatch, SetStateAction } from "react";
import { IGaussResponse } from "../../../dto/converters/IGaussResponse";
import {useTranslation} from 'react-i18next';

const GaussGlobalLocationsSelect = (props: {setFormData: Dispatch<SetStateAction<{sourceFormat: string, resultFormat: string,  inputData: IGaussResponse[]}>>, formData: {sourceFormat: string, resultFormat: string,  inputData: IGaussResponse[]}, isSource: boolean}) => {
    
    const setFormData = props.setFormData;
    const formData = props.formData;
    const {t} = useTranslation();

    //<option value="9">Läti TM</option>

    return (
        <>
            <Form.Select onChange={e => props.isSource ? setFormData({ ...formData, sourceFormat: e.target.value }) : setFormData({ ...formData, resultFormat: e.target.value })}>
                <option value="1">1. {t('gaussFormOption1')}</option>
                <option value="2">2. {t('gaussFormOption2')}</option>
                <option value="3">3. {t('gaussFormOption3')}</option>
                <option value="4">4. {t('gaussFormOption4')}</option>
                <option value="5">5. {t('gaussFormOption5')}</option>
                <option value="6">6. {t('gaussFormOption6')}</option>
                <option value="7">7. {t('gaussFormOption7')}</option>
                <option value="8">8. {t('gaussFormOption8')}</option>
                <option value="9">9. L-EST97</option>
                <option value="10">10. {t('gaussFormOption10')}</option>
                <option value="11">11. EUREF-EST97 Gauss-Krüger 21</option>
                <option value="12">12. EUREF-EST97 Gauss-Krüger 24</option>
                <option value="13">13. EUREF-EST97 Gauss-Krüger 27</option>
                <option value="14">14. EUREF-EST97 UTM34</option>
                <option value="15">15. EUREF-EST97 UTM35</option>
            </Form.Select>
        </>
    );

}

export default GaussGlobalLocationsSelect;
